import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "fripri_cookie_consent";

// Mode app installée (coque iOS, TWA Android, PWA) : cookies strictement nécessaires uniquement → pas de bannière
const isInstalledApp = () => {
  try {
    return (
      window.matchMedia?.("(display-mode: standalone)")?.matches ||
      window.navigator.standalone === true ||
      !!window.webkit?.messageHandlers ||
      document.referrer.startsWith("android-app://")
    );
  } catch {
    return false;
  }
};

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isInstalledApp()) return;
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) setVisible(true);
    } catch (e) {
      // localStorage unavailable (private mode) — show the banner anyway
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() })); }
    catch (e) { console.error("Cookie consent storage failed:", e); }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[80] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto bg-black text-white border-2 border-[color:var(--color-mint)] p-4 sm:p-5 shadow-2xl flex flex-col sm:flex-row gap-4 items-start sm:items-center">
        <Cookie size={28} strokeWidth={2.5} className="text-[color:var(--color-mint)] shrink-0"/>
        <div className="flex-1 text-xs sm:text-sm">
          <p className="font-bold mb-1">Cookies essentiels uniquement 🍪</p>
          <p className="text-white/80">
            Fripri utilise des cookies strictement nécessaires (authentification, panier). 
            Aucun tracking, aucune publicité. <Link to="/cookies" className="underline">En savoir plus</Link>.
          </p>
        </div>
        <button
          onClick={accept}
          className="btn btn-sm bg-[color:var(--color-mint)] text-black border-2 border-[color:var(--color-mint)] hover:bg-white hover:border-white shrink-0 w-full sm:w-auto"
          data-testid="cookie-accept-btn"
        >
          Compris
        </button>
      </div>
    </div>
  );
}
